// Deal prep config shape and pure helpers (no Supabase client), so the settings
// form can be tested without the app (REG-859).

/** core_crm.global_setting.deal_prep_config (REG-847 ff.). */
export type DealPrepConfig = Record<string, unknown> & {
  version: 1;
  sandbox: boolean;
  sandbox_recipient: string;
  to: string[];
  cc: string[];
  admin_sender: { email: string; name: string };
  brands: Record<string, { persona_email: string; persona_name: string; cc?: string[] }>;
  instantly_cc?: string[];
  test_addresses?: string[];
  test_address_patterns?: string[];
  duplicate_window_minutes?: number;
  merchant_link_guard?: 'off' | 'log' | 'enforce';
  chain_join_hours?: number;
  chain_shopping_days?: number;
  intake_brands?: string[];
  upload_brands?: string[];
  instantly?: { rep_email?: string; brand?: string; senders?: string[]; link_days?: number };
  mail_watch?: { live?: boolean; since?: string; manual_alerts?: boolean; chain_files?: boolean; instantly?: boolean } & Record<string, unknown>;
  brand_rep_mailboxes?: Record<string, string[]>;
  timers?: {
    statements_request_minutes?: number;
    statements_reminder_hours?: number;
    upload_wait_minutes?: number;
    instantly_wait_minutes?: number;
  };
  drive?: { root_folder_id: string; owner_email: string; unmatched_folder?: string };
};

export const DEAL_PREP_BRANDS = ['SKYLINE', 'HILTON', 'FRANKLIN', 'ORION', 'EDEN'] as const;

/** Brands whose /upload page posts to the CRM; REGION has an upload page but no e-sign intake. */
export const DEAL_PREP_UPLOAD_BRANDS = [...DEAL_PREP_BRANDS, 'REGION'] as const;

const EMAIL_RE = /^[^@\s]+@[^@\s]+$/;

/** "a@x.com, b@y.com" -> ["a@x.com", "b@y.com"]; returns the bad entries too. */
export function parseEmailList(value: string): { emails: string[]; invalid: string[] } {
  const parts = value.split(/[,\n]/).map((p) => p.trim().toLowerCase()).filter(Boolean);
  return { emails: parts.filter((p) => EMAIL_RE.test(p)), invalid: parts.filter((p) => !EMAIL_RE.test(p)) };
}

export function isEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
